export enum DynamicFormFieldTypes {
  FILE = 'file', // NOTE: in strapi they are using MEDIA type instead with option of [Multiple Media, Single Media]
  TEXT = 'string',
  RELATIONSHIP = 'relationship',
  RADIO = 'radio',
  SELECT = 'select',
  NUMBER = 'integer',
  CHECKBOX = 'checkbox',
  LONG_TEXT = 'longtext',
}

export enum DocumentStatus {
  PUBLISHED = 'published',
  NOT_PUBLISHED = 'not published',
}

export enum FolderManagerItemActionNames {
  EDIT,
  DELETE,
  RESTORE,
  SHARE,
  DOWNLOAD,
  DOWNLOAD_DECK,
  RENAME,
  UPLOAD,
  MANAGE_VERSIONS,
  MOVE,
  EXPORT,
  ADD_TO_PRESENTATION,
  ADD_TO_CATEGORY,
  REMOVE_FROM_PRESENTATION,
  MANAGE_THEME,
  COPY,
  CLONE,
  SET_AS_DEFAULT,
  PREVIEW_THEMES,
  SHOW_DETAILS,
  PIN,
  REMOVE_PIN,
  SLIDE_DOWNLOAD,
  ADD_SUBFOLDER,
  REMOVE,
}

export enum FolderManagerItemActionTypes {
  SINGLE,
  MULTI,
}

export enum SlideRowDisplayLevel {
  New = 'new',
  Similar = 'similar',
  Duplicate = 'duplicate',
}

export enum ClassificationOption {
  NewSlide = 'new_slide',
  VersionUpdate = 'version_update',
  Duplicate = 'duplicate',
}
